import { object, string, number, boolean } from 'zod';

export const SmsOptInSchema = object({
  enabled: boolean().optional(),
  modalAppearanceDelaySeconds: number().int().min(1).optional(),
  optInAcceptedLoyaltyEventName: string().optional(),
  optInRejectedLoyaltyEventName: string().optional(),
}).strict();
